import type { SessionWarningModalProps } from "@webuild-ai/react-auth";

import { SessionWarningModal } from "@webuild-ai/react-ui/components";
import React, { useCallback } from "react";

/**
 * Warning modal slot that defers `onLogout` to a macrotask.
 *
 * react-ui's `SessionWarningModal` calls `onLogout()` from inside a `setState` updater
 * when its countdown reaches zero. React invokes updaters during the render phase, so
 * calling straight back into `SessionTimeoutProvider` there produces a "Cannot update a
 * component while rendering a different component" warning and fires the logout twice
 * under StrictMode. Deferring moves the call out of the render phase; the single-flight
 * guard in `useAppLogout` absorbs the duplicate.
 *
 * This lives in its own module rather than inside `main.tsx` so the deferral can be
 * covered by a unit test. `main.tsx` is excluded from coverage and has no test harness.
 */
export const DeferredSessionWarningModal: React.FC<SessionWarningModalProps> = (props) => {
  const { onLogout } = props;

  const deferredLogout = useCallback(() => {
    setTimeout(onLogout, 0);
  }, [onLogout]);

  return <SessionWarningModal {...props} onLogout={deferredLogout} />;
};

export default DeferredSessionWarningModal;
